<template>
  <div class="row">
    <div class="col-lg-12 col-xs-12">
      <span class="ml-3 f14 font-weight-bold text-uppercase">
        Comunicações
      </span>
      <br />

      <span class="ml-3 f14 color-primary">
        ADICIONE COMUNICAÇÕES ESPECÍFICAS PARA ESSA VAGA
      </span>
    </div>
    <div class="col-lg-4 col-xs-12 mt-3" v-if="!show_form">
      <button
        class="btn btn-primary full p-2 radius-0 f13 text-uppercase"
        @click="() => (show_form = true)"
      >
        Adicionar comunicação
      </button>
    </div>

    <div class="col-lg-4 col-xs-12 mt-3" v-else>
      <button
        class="btn btn-danger full p-2 radius-0 f13 text-uppercase"
        @click="removeCommunication"
      >
        Remover comunicação
      </button>
    </div>
    <div class="col-lg-12 col-xs-12 mt-3" v-if="show_form">
      <div class="row">
        <div class="col-lg-12 col-xs-12 mt-3">
          <select
            class="form-control"
            v-model="communication.communication_type"
          >
            <option
              v-for="(type, index) in communication_types"
              :key="index"
              :value="type.id"
            >
              {{ type.label }}
            </option>
          </select>
        </div>

        <div class="col-lg-12 col-xs-12 mt-3">
          <label>Limite de notificações</label>
          <input
            v-model="communication.max_attempts"
            type="number"
            class="form-control"
          />
        </div>

        <div class="col-lg-12 col-xs-12 mt-3">
          <label>Assunto</label>
          <input
            v-model="communication.subject"
            type="text"
            class="form-control"
          />
        </div>

        <div class="col-lg-12 col-xs-12 mt-3">
          <label> Mensagem (preferência em HTML, mas não obrigatório) </label>
          <textarea
            v-model="communication.body"
            rows="4"
            class="form-control"
            placeholder="Escreva aqui a mensagem que será enviada ao candidato"
          />
        </div>
        <div class="col-lg-12 col-xs-12 mt-3">
          <button
            class="btn btn-primary full p-2 radius-0 f13 text-uppercase"
            @click="save"
          >
            Salvar
          </button>
        </div>
      </div>
    </div>
    <div class="col-lg-12 col-xs-12"></div>
  </div>
</template>
<script>
export default {
  props: {
    current_job: {
      type: Object,
      default: null,
      required: true,
    },
  },
  components: {},
  mounted() {
    this.communication.communicable_id = this.current_job.id;
    this.findCommunications();
  },
  data: () => ({
    show_form: false,
    communication: {
      id: null,
      body: "",
      subject: "",
      max_attempts: 0,
      communicable_id: 0,
      communicable_type: "Job",
      communication_type: 0,
    },
    communication_types: [{ id: 0, label: "Concluir prova" }],
  }),
  methods: {
    removeCommunication() {
      if (this.communication.id == null) {
        this.show_form = false;
        return;
      }

      axios
        .delete(`/recruiters/communications/${this.communication.id}`)
        .then(() => {
          this.show_form = false;
          this.communication = {
            id: null,
            body: "",
            subject: "",
            max_attempts: 0,
            communicable_id: this.current_job.id,
            communicable_type: "Job",
            communication_type: 0,
          };
        })
        .catch((error) => {
          console.log(error);
        });
    },
    findCommunications() {
      axios
        .get(
          `/recruiters/communications/${this.communication.communicable_id}/job`
        )
        .then((response) => {
          if (response.data != null) {
            this.communication = response.data;
            this.show_form = true;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    save() {
      let url = "/recruiters/communications";

      if (this.communication.id != null) {
        url += `/${this.communication.id}`;
      } else {
        delete this.communication.id;
      }

      axios
        .post(url, this.communication)
        .then((response) => {
          this.communication = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
